import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=b0aad246&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
import style0 from "./Summary.vue?vue&type=style&index=0&id=b0aad246&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aad246",
  null
  
)

export default component.exports